import styled from 'styled-components/macro';
import Button from 'components/Button';

export const Wrapper = styled.section`
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: var(--color-gray-200);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  padding: 25px;
  ${({ theme }) => theme.media.md`
    padding: 40px;
  `}
`;

export const Text = styled.p`
  font-size: 14px;
  color: var(--color-main-light);
  font-weight: 500;
`;

export const StyledButton = styled(Button)`
  max-height: 80px;
  margin-left: 5px;
  ${({ theme }) => theme.media.md`
    margin-left: 0;
  `}
`;
